<template>
  <!--对话总体-->
  <div class="mess">
    <!--用户列表-->
    <div class="mess_user_list">
      <!--用户本人-->
      <div class="user">
        <span>即时通讯</span>
      </div>
      <!--其他用户或群-->
      <div class="user_list">
        <div v-for="(item, index) in ChatMessage" :key="index" @click="showmessdlog(item)" class="user_list_item">
          <img class="headimg" :src="item.HeadImg?item.HeadImg:userAvatar" style="margin: 5px;" />
          <div>
            <span>{{item.Name}}</span>
            <p v-if="item.Content" style="font-size: 10px;margin: 0px;margin-top: 4px;color:#a19f9f;">{{convertimg(item.Content)==0?'【图片】':convertimg(item.Content)==2?'【文件】':convertimg(item.Content)==4?'视频通讯':convertimg(item.Content).msgType=='text'?convertimg(item.Content).text:item.Content}}</p>
            <p v-else style="font-size: 10px;margin: 0px;margin-top: 4px;color:#a19f9f;">暂无消息</p>
          </div>
          <i v-if="item.MsgState==0">·</i>
        </div>
      </div>
    </div>
    <!--有对话时，对话框-->
    <div class="mess_dialog" v-if="SenderID">
      <!--对话框头部-->
      <div class="dlog_header">
        <span style="margin-left: 25px;">{{acceptUser}}</span>
      </div>
      <!--对话框内容-->
      <div class="dlog_content" ref="mianscroll">
        <div v-for="(item, index) in messnowList" :key="index" class="dlog_content_item" style="margin-left: 5px;">

          <!--其他用户的消息展示-->
          <div v-if="item.SendID!=UserID" class="content_other">
            <img class="headimg" :src="item.HeadImg?item.HeadImg:userAvatar" style="margin: 5px;" />
              <span class="Basicinfo">{{item.SenderName}}   {{item.SendTime}}</span>
              <div class="Message">
                <p v-if=" convertimg(item.Message)==0" style="max-width:300px;background:none;"><img :src="item.Message"></p>
                <p class="file" v-else-if="item.KeyID=='file' || convertimg(item.Message)==2">
                  <span style="width:50px;display:inline-block;">
                    <img v-if="getFileType(item.Message)=='doc' || getFileType(item.Message)=='docx'" src="@/assets/img/ic_word.png">
                    <img v-else-if="getFileType(item.Message)=='pdf'" src="@/assets/img/ic_pdf.png">
                    <img v-else-if="getFileType(item.Message)=='ppt'" src="@/assets/img/ic_ppt.png">
                    <img v-else-if="getFileType(item.Message)=='xlsx' || getFileType(item.Message)=='xls'" src="@/assets/img/io_excel.png">
                  </span>
                  <label style="padding:10px 10px 0">{{splitstr(item.Message)}}</label>
                </p>
                <p v-else-if="convertimg(item.Message)==4 || item.KeyID=='start'" style="max-width:300px;background:none;">
                  视频通讯 <i class="el-icon-video-camera"></i>
                </p>
                <p v-else-if="convertimg(item.Message).msgType=='text'">{{ convertimg(item.Message).text }}</p>
                <p v-else>{{item.Message}}</p>
                <a :href="item.Message" class="el-icon-bottom down_icon" v-if="item.KeyID=='file' || convertimg(item.Message)==2"></a>
              </div>
            </div>
          <!--本用户的消息展示-->
          <div v-else class="content_me">
              <span class="Basicinfo">{{item.SendTime}}  {{item.SenderName}}</span>
              <img class="headimg" :src="item.HeadImg?item.HeadImg:userAvatar" style="margin: 5px;" />
              <div class="Message">
                <a :href="item.Message" class="el-icon-bottom down_icon" v-if="item.KeyID=='file' || convertimg(item.Message)==2"></a>
                <p v-if="convertimg(item.Message)==0" style="max-width:300px;background:none;"><img :src="item.Message"></p>
                <p class="file" v-else-if="item.KeyID=='file' || convertimg(item.Message)==2">
                  <label style="padding:10px 10px 0">{{splitstr(item.Message)}}</label>
                  <span style="width:50px;display:inline-block;">
                    <img v-if="getFileType(item.Message)=='doc' || getFileType(item.Message)=='docx'" src="@/assets/img/ic_word.png">
                    <img v-else-if="getFileType(item.Message)=='pdf'" src="@/assets/img/ic_pdf.png">
                    <img v-else-if="getFileType(item.Message)=='ppt'" src="@/assets/img/ic_ppt.png">
                    <img v-else-if="getFileType(item.Message)=='xlsx' || getFileType(item.Message)=='xls'" src="@/assets/img/io_excel.png">
                  </span>
                </p>
                <p v-else-if="convertimg(item.Message)==4 || item.KeyID=='start'" style="max-width:300px;background:none;">
                  <i class="el-icon-video-camera"></i> 视频通讯
                </p>
                <p v-else-if="convertimg(item.Message).msgType=='text'">{{ convertimg(item.Message).text }}</p>
                <p v-else>{{item.Message}}</p>
              </div>
            </div>
        </div>
      </div>


      <!--对话框底部-->
      <div class="dlog_footer">
        <div class="tool">
          <i class="ic_emoj" @mouseover="mouseoveremoji" @mouseout="mouseoutemoji">
            <img src="@/assets/img/ic_emoj.png">
           <!-- 表情 -->
            <div class="emoji" :style="{visibility:emoji}">
              <picker Locale="中文" :showSearch="false" :showPreview="false" :showCategories="true" @select="addEmoji"/>
            </div>
          </i>
          <i class="el-icon-picture-outline">
            <el-upload
              :action="actionUrl"
              :headers="{
                  Authorization:Authorization
                }"
              :show-file-list="false"
              accept="image/" 
              name="images"
              style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;"
              :on-success="handleAvatarSuccess">
              <el-button style="width: 26px;height: 26px!important;padding: 0;">上传</el-button>
            </el-upload>
          </i>
          <i class="el-icon-folder-opened">
            <el-upload  :action="actionUrl"  :show-file-list="false" name="images" style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;" :on-success="handlefileSuccess">
              <el-button style="width:26px;height:26px!important;padding: 0;">上传</el-button>
            </el-upload>
          </i>
          <i class="el-icon-video-camera" @click="clickvideo('send')"></i>
        </div>
        <el-input type="textarea" :rows="5" v-model="mess"></el-input>
        <el-button type="primary" @click="Wssendmess" style="float: right;margin:5px 10px 0;" :disabled="mess?false:true">发送</el-button>
      </div>
    </div>
    <!--无对话时，对话框-->
    <div v-else class="mess_dialog_false">
      <span>暂无消息，请选择用户对象</span>
    </div>

    <!-- 图片弹窗 -->
    <el-dialog :visible.sync="dialogVisible" width="30%" :show-close="false" :before-close="handleClose">
      <p style="text-align: center;font-size: 20px;padding: 0 0 30px;">是否确认发送图片？</p>
      <div class="upimg">
        <img :src="upimg" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false;">取 消</el-button>
        <el-button type="primary" @click="confirm">发 送</el-button>
      </span>
    </el-dialog>

    <!-- 发送文件弹窗提醒 -->
    <el-dialog style="margin: auto;text-align: center;" :visible.sync="filedialogVisible" width="30%" :show-close="false" :before-close="handleClose">
      <p style="text-align: center;font-size: 20px;padding: 0 0 30px;">是否确认发送文件？</p>
      <div class="fileclass">
        {{fileName}}
        <span style="display: inline-block;width:40px;margin-left: 20px;">
          <img v-if="getFileType(fileName)=='doc' || getFileType(fileName)=='docx'" src="@/assets/img/ic_word.png">
          <img v-else-if="getFileType(fileName)=='pdf'" src="@/assets/img/ic_pdf.png">
          <img v-else-if="getFileType(fileName)=='ppt'" src="@/assets/img/ic_ppt.png">
          <img v-else-if="getFileType(fileName)=='xlsx' || getFileType(fileName)=='xls'" src="@/assets/img/io_excel.png">
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="filedialogVisible = false;">取 消</el-button>
        <el-button type="primary" @click="fileconfirm">发 送</el-button>
      </span>
    </el-dialog>

    <!-- 视频弹窗 -->
    <div class="videodialog" v-show="videodialog">
      <div class="header">
        <span>正在与{{acceptUser}}视频通话</span>
        <!-- <span class="center">00:10:24</span> -->
        <span class="right">
          <!-- <i class="el-icon-minus"></i>
          <i class="el-icon-copy-document"></i> -->
          <i class="el-icon-close" @click="closevideo"></i>
        </span>
      </div>
      <div class="video">
        <video id="remoteVideo" style="width: 100%;height: 100%;"></video>
        <div class="avatar" v-if="waiting">
          <el-avatar :size="150" :src="circleUrl"></el-avatar>
        </div>
        <div class="remoteVideo" v-show="localVideoShow">
          <i class="el-icon-error" @click="localVideoShow=false"></i>
          <video id="localVideo" style="width: 100%;height: 100%;"></video>
        </div>
        
      </div>
      <div class="fotter">
        <div class="item bullhorn" @click="Clickbullhorn">
          <i v-if="bullhorn"><img src="@/assets/bullhorn_open.png"></i>
          <i v-else><img src="@/assets/bullhorn_close.png"></i>
          <p>{{bullhorn?'扬声器已开':'扬声器关闭'}}</p>
        </div>

        <!-- <div class="item" @click="ClickAudio">
          <i v-if="isaudio"><img src="@/assets/mike_open.png" alt=""></i>
          <i v-else><img src="@/assets/mike_close.png" alt=""></i>
          <p>{{isaudio?'麦克风已开':'麦克风关闭'}}</p>
        </div> -->

        <div class="footer_btn">
          <div class="hangup btn" @click="closevideo" v-if="connect">
            <i class="el-icon-phone"></i>
            挂断
          </div>
          
          <div class="cancel btn" @click="closevideo" v-if="waiting && UserID == messagedata.from">
            <i class="el-icon-close"></i>
            取消
          </div>

          <div class="agree btn" @click="callfun" v-if="waiting && UserID == messagedata.from">
            <i class="el-icon-video-camera"></i>
            {{connecting?'接通中':'接受'}}
          </div>

        </div>
        
      </div>
    </div>
  </div>
</template>
<script>

import userAvatar from '@/assets/consult/head.png'
import '../../../static/peerjs.min.js'
import { Picker } from "emoji-mart-vue"; //引入组件
const UserID =JSON.parse(sessionStorage.getItem('xinxi')).UserID;
let WebSocketUrl=process.env.VUE_APP_Web+'websocket?id=' + UserID;
var ws =new WebSocket(WebSocketUrl);
var acceptUserId='';
var peer=null;
// var ws =new WebSocket('wss://www.bcxl.cn:9239/websocket?id=' + UserID);
export default {
name: 'Teleconsultation',
data () {
  return {
    actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
    Authorization:sessionStorage.getItem('Authorization'),
    upimg:"",
    fileName:'国科大PC端接口.docx',
    dialogVisible:false,
    filedialogVisible:false,
    emoji:'hidden',
    userAvatar:userAvatar,
    mess: '',//输入的信息
    updatatype:'text',
    SenderID:'',
    ChatMessage:[],
    acceptUser:'',
    UserID:UserID,
    messnowList: [], //当前对话用户的-聊天内容列表
    // 视频相关
    videodialog:false,
    localStream:null,
    lastremoteStream:null,
    isrun:true,
    remoteId:null,
    localVideoShow:true,
    messagedata:null,
    circleUrl:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
    isanswer:false,
    waiting:false,
    connect:true,
    bullhorn:true,
    isaudio:true,
    connecting:false
  }
},
// 初始化
created () {
  this.GetChatMessage();
},
mounted () {
  ws.addEventListener('open', this.handleWsOpen.bind(this), false)
  // ws.addEventListener('close', this.handleWsClose.bind(this), false)
  ws.addEventListener('error', this.handleWsError.bind(this), false)
  ws.addEventListener('message', this.handleWsMessage.bind(this), false)
},
methods: {
  // 发送按钮点击事件
  async Wssendmess () {   
    // 判断是否全是空格
    var message = this.mess.replace(/\s+/g, '')
    if (message !== '') {
      // 发送消息格式
      var obj = JSON.stringify({
        from:UserID,//发送者id
        to: this.SenderID,//接受者id
        content: this.mess,//发送内容
        sendTime:this.Global.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        type:this.updatatype
      })
      // 发送消息
      ws.send(obj);
      // 发送完消息，重新输入框
      this.mess = '';
      this.emoji=false;
    }else{
      this.$message({type: 'warn', message:"请输入内容"});
    }
  },
  handleWsOpen (e) {
    this.$message({type: 'success', message:"已建立连接"});
  },
  handleWsClose (e) {
    this.$message({type: 'error', message:"连接已关闭"});
  },
  handleWsError (e) {
    this.$message({type: 'error', message:"连接错误"});
  },
  // 断开连接
  closebind(){
    ws.close();
      ws.addEventListener('close', this.handleWsClose.bind(this), false)
  },
  handleWsMessage (e) {
    var obj = JSON.parse(e.data);
    if(obj.type=='start' || obj.type=="command"){
      if(UserID==obj.from){
        this.SenderID=obj.to;
        acceptUserId=obj.to;
      }else{
        this.SenderID=obj.from
        acceptUserId=obj.from;
      }
      this.VideoMessage(e);
      return false;
    }
    let data={
      UserID:obj.to,
      SendID:obj.from,
      Message:obj.content,
      SendTime:obj.sendTime,
      type:this.updatatype
    }
      // 强制刷新
      this.$forceUpdate()
      this.messnowList.push(data);
      let scrollEl = this.$refs.mianscroll;
      setTimeout(()=> {
          scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
      }, 100);
      for(let item of this.ChatMessage){
        if(item.Counselor==obj.to){
          item.Content=obj.content;
          this.acceptUser=item.Name;
        }
      }
  },

  // 发送消息后，列表处需要更新
  GetChatMessage(){
    this.$Http_Post('ConsultAppoint/GetChatMessage',{UserID:UserID}).then(res=>{
      if(res.Code==0){
        this.ChatMessage=res.Data;
      }else{
        this.$message({type: 'error', message:res.Message});
      }
    })
  },

  // 获取对话列表
  getuserList () {
    this.$Http_Post('ConsultAppoint/GetChatMessage',{UserID:UserID,SenderID:this.SenderID}).then(res=>{
      if(res.Code==0){
        this.messnowList=res.Data;
        let scrollEl = this.$refs.mianscroll;
        setTimeout(()=> {
            scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
          }, 100);
      }
    })
  },
  // 展示对话框
  showmessdlog (item) {
    if(this.dialogVisible){
      this.$message({type: 'error', message:'视频咨询期间，无法操作'});
      return false;
    }
    if(this.SenderID==item.Counselor){
      return false;
    }
    this.acceptUser = item.Name
    acceptUserId = item.Counselor;
    this.SenderID=item.Counselor;
    this.getuserList();
  },
  mouseoveremoji(){
    this.emoji='visible';
  },
  mouseoutemoji(){
    this.emoji='hidden';
  },
  // 选择表情
  addEmoji(e){
    this.mess +=e.native;
  },
  handleClose(){},
  // 发送图片
  handleAvatarSuccess(file,fileList){
    this.upimg = file.Data;
    this.dialogVisible=true;
  },
  // 上传文件
  handlefileSuccess(file,fileList){
    this.upimg = file.Data;
    this.fileName=fileList.name;
    this.filedialogVisible=true;
  },
  confirm(){
    this.dialogVisible=false; 
    this.mess=this.upimg;
    this.updatatype='img';
    this.Wssendmess();
  },
  fileconfirm(){
    this.filedialogVisible=false; 
    this.mess=this.upimg;
    this.updatatype='file';
    this.Wssendmess();
  },
  convertimg(str){
    let imgRegex = /(http?:\/\/.*\.(?:jpg|jpeg|png|gif))/g;//图片
    let fileRegex = /(http?:\/\/.*\.(?:pdf|doc|docx|xls|xlsx|ppt))/g;//文件
    if (str.match(imgRegex)) {
        return 0;
    }else if(str.match(fileRegex)){
      return 2;
    }else if(str.includes('type\":\"start\"')){
      return 4;
    }else if(str.includes('msgType\":\"text\"')){
      let data=JSON.parse(str);
      return data;
    }else{
      return 1;
    }
  },
  // 截取反斜杠后的字符串
  splitstr(str){
    let parts = str.split("\\");
    let result = parts[1].slice(0);
    return result
  },
  // 获取文件类型
  getFileType(url) {
      var urlParts = url.split('.');
      var fileExtension = urlParts[urlParts.length - 1];
      return fileExtension;
  },
  // 视频
  clickvideo(data){
    var _this=this;
    let localVideo=document.getElementById('localVideo');
    let remoteVideo=document.getElementById('remoteVideo');
    if(!navigator.mediaDevices){
      _this.$message.warning("请先打开摄像头权限");
            return false;
      }
      _this.getUserMedia({video: true, audio: true}, function(stream) {
        _this.videodialog=true;
        _this.localStream=stream;
        localVideo.srcObject = stream;
        localVideo.autoplay = true;
            if(_this.isrun){
                _this.waiting=false;
                peer = new Peer();
                peer.on('open', function(id) {
                    ws.send(JSON.stringify({ 'from':UserID, 'to':acceptUserId, 'content':JSON.stringify({id:id,identity:data,type:'start'}),'sendTime':_this.Global.formatDate(new Date(),'YYYY-MM-DD HH:mm:ss'), 'type':_this.messagedata?'command':'start'}));
                });
                peer.on('call', function(call) {
                    call.answer(_this.localStream);
                    call.on('stream', function(remoteStream) {
                      _this.lastremoteStream=remoteStream;
                      remoteVideo.srcObject = remoteStream;
                      remoteVideo.autoplay = true;
                    });
                });
            }
            localVideo.play();
        }, function(err) {
          console.log(err);
            _this.$message.error("请检查是否安装摄像头");
        });
  },
  callfun(){
    var _this=this;
    this.connecting=true;
    let remoteVideo=document.getElementById('remoteVideo');
    _this.call = peer.call(_this.remoteId,_this.localStream);
    _this.call.on('stream', function(remoteStream) {
      _this.lastremoteStream=remoteStream;
            remoteVideo.srcObject = remoteStream;
            remoteVideo.autoplay = true;
            var josncon=JSON.parse(_this.messagedata.content);
            josncon['type']='connect';
            ws.send(JSON.stringify({ 'from':UserID, 'to':acceptUserId, 'content':josncon,'sendTime':_this.Global.formatDate(new Date(),'YYYY-MM-DD HH:mm:ss'), 'type':'command'}));
        });
        _this.call.on('close', function() {
            console.log("call close");
        });
        _this.call.on('error', function(err) {
            console.log(err);
        });
    },
  closevideo(){
    ws.send(JSON.stringify({ 'from':UserID, 'to':acceptUserId, 'content':JSON.stringify({type:'end'}),'sendTime':this.Global.formatDate(new Date(),'YYYY-MM-DD HH:mm:ss'), 'type':'command'}));
  },
  //访问用户媒体设备的兼容方法
  getUserMedia(constrains,success,error){
        if(navigator.mediaDevices.getUserMedia){
            //最新标准API
            navigator.mediaDevices.getUserMedia(constrains).then(success).catch(error);
        } else if (navigator.webkitGetUserMedia){
            //webkit内核浏览器
            navigator.webkitGetUserMedia(constrains).then(success).catch(error);
        } else if (navigator.mozGetUserMedia){
            //Firefox浏览器
            navagator.mozGetUserMedia(constrains).then(success).catch(error);
        } else if (navigator.getUserMedia){
            //旧版API
            navigator.getUserMedia(constrains).then(success).catch(error);
        }
    },
    VideoMessage(e){
        this.messagedata=JSON.parse(e.data);
        var jsoncon=null;
        jsoncon=JSON.parse(this.messagedata.content);
        if(jsoncon.type=="start"){
          if(this.SenderID!=this.messagedata.to){
            this.remoteId=jsoncon.id;
              if(jsoncon.identity=='send'){
                  this.clickvideo('');
              }
          }
          if(this.messagedata.type=='command'){
              this.connect=false;
              this.waiting=true;
          }
      }else if(jsoncon.type=="connect"){
        this.connect=true;
        this.waiting=false;
      }else if(jsoncon.type=="end"){
        this.connecting=false;
        this.localStream.getVideoTracks()[0].stop();
        this.localStream.getAudioTracks()[0].stop();
        if(this.lastremoteStream){
          this.lastremoteStream.getVideoTracks()[0].stop();
          this.lastremoteStream.getAudioTracks()[0].stop();
        }
        this.videodialog=false;
      }
    },
    // 扬声器
    Clickbullhorn(){
      let remoteVideo=document.getElementById('remoteVideo');
      let localVideo=document.getElementById('localVideo');
      if(this.bullhorn){
        remoteVideo.muted=true;//扬声器噤声
        localVideo.muted=true
        this.bullhorn=false;
      }else{
        remoteVideo.muted=false;
        localVideo.muted=false
        this.bullhorn=true;
      }
    },
    // 麦克风
    ClickAudio(){
      this.isaudio=!this.isaudio;
      this.clickvideo('')
    }
},
components: { //注册组件，不能全局挂载
    Picker
  }
}
</script>

<style scoped>
.mess{border-radius: 5px;background-clip: padding-box;margin:20px auto;border: 1px #cecdcd;box-shadow: 0 0 10px #9b9393;background-color: white;display: flex;min-width:980px;}
.mess_user_list{width: 270px;border-right:1px solid #cecdcd;}
.mess_dialog{width: 100%;padding:0 0 10px;}
.mess_dialog_false{width: 680px;text-align: center;line-height: 600px;}
.dlog_header{height:60px;border-bottom: 1px solid #cecdcd;display: flex;align-items: center;}
.dlog_content{height: 370px;border-bottom: 1px solid #cecdcd;overflow-y: auto;padding-bottom:30px;}
.user{height: 60px;width: 270px;display: flex;align-items: center;border-bottom: 1px solid #cecdcd;}
.user span{padding:0 10px;font-size:16px}
.user_list{height: 540px;overflow-y: auto;overflow-x:hidden;}
.user_list_item{border-bottom: 1px solid #cecdcd;display: flex;align-items: center;padding:5px 10px;position: relative;}
.user_list_item>i{position: absolute;right:10px;font-size: 30px;top: 50%;line-height: 0;color: red;}
.headimg{width:35px;height:35px;display:inline-block;border-radius:50%;}
.content_other{margin:0 30px;}
.content_me{text-align: right;margin:0 30px;}
.Basicinfo{position:relative;top:-15px;font-size:10px;color:rgb(161, 159, 159);}
.el-textarea{display: block;width: auto;margin:10px;}
.Message{font-size:14px;margin:0 40px 0;}
.Message p{background:#e3e1e1;display:inline-block;padding:5px 10px;border-radius:4px;}
.Message .file{background:#f5f5f5!important;display:inline-flex;}
.Message .down_icon{background:green;border-radius:50%;color:#fff;padding:3px;;margin:0 10px;cursor:pointer;}
.content_me .Message p{background:#95ec69;}
.tool{margin:0 5px;}
.tool i{padding:10px 5px 0;font-size:16px;position:relative;font-weight: 100;color: #9b9393;}
.tool .ic_emoj{width:16px;top:2px;display:inline-block;}
.dlog_footer{position:relative;}
.emoji{position: absolute;bottom:25px;width:600px;visibility:hidden;left:-10px;}
.emoji-mart{width:100%!important;}
.upimg{width:60%;margin:auto;}
img{width:100%;display:block;}
.fileclass{background: #f5f5f5;border-radius: 8px;padding:10px 20px;display: inline-flex;}
/*滚动条样式*/
::-webkit-scrollbar {/*滚动条整体样式*/
            width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
            height: 4px;
        }
        ::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
        }
        ::-webkit-scrollbar-track {/*滚动条里面轨道*/
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);
        }

/* 视频弹窗 */
.videodialog{background: #323232;width: 785px;height:544px;border-radius: 8px;position: absolute;top:50%;left:50%;margin: -272px -330px;border: 1px solid #424242;}
.videodialog .header{color: #fff;height: 40px;display: flex;align-items: center;padding: 0 15px;justify-content: space-between;position: relative;}
.videodialog .header span{position: relative;z-index: 2;}
.videodialog .header .center{position: absolute;width: 100%;text-align: center;left: 0;top: 0;line-height: 40px;z-index: 1;}
.videodialog .header .right i{margin:0 0 0 10px;cursor: pointer;}
.videodialog .video{width: 100%;height: 440px;position: relative;}
.videodialog .video .avatar{position:absolute;top:50%;left: 50%;transform: translate(-50%,-50%);}
.videodialog .video .remoteVideo{position: absolute;bottom:0;right: 0;width: 170px;height: 170px;background: #fff;}
.videodialog .video .remoteVideo i{font-size: 20px;margin: 5px;position: absolute;top: 0;right: 0;z-index: 2;}
.videodialog .fotter{display: flex;color: #fff;position: relative;height: 64px;}
.videodialog .fotter .item{margin:10px 15px;}
.videodialog .fotter .item i{width:24px;display: block;margin: auto;}
.videodialog .fotter .hangup{background: #EC5344;}
.videodialog .fotter .hangup i{transform: rotate(135deg);}
.videodialog .fotter .footer_btn{position: absolute;right:20px;top: 15px;width: 500px;text-align: right;}
.videodialog .fotter .footer_btn .btn{border-radius: 200px;font-size: 16px;line-height: 34px;padding: 0 30px;color: #fff;display: inline-block;margin-left: 10px;}
.videodialog .fotter .footer_btn .cancel{background: #EC5344;}
.videodialog .fotter .footer_btn .agree{background: #2499FF;}
.videodialog img{width: 100%;}
</style>